import png1 from "../../../assets/img/landings/nextres/what-we-did/1.png";
import webp1 from "../../../assets/img/landings/nextres/what-we-did/1.webp";
import png2 from "../../../assets/img/landings/nextres/what-we-did/2.png";
import webp2 from "../../../assets/img/landings/nextres/what-we-did/2.webp";
import png3 from "../../../assets/img/landings/nextres/what-we-did/3.png";
import webp3 from "../../../assets/img/landings/nextres/what-we-did/3.webp";
import png4 from "../../../assets/img/landings/nextres/what-we-did/4.png";
import webp4 from "../../../assets/img/landings/nextres/what-we-did/4.webp";
import png5 from "../../../assets/img/landings/nextres/what-we-did/5.png";
import webp5 from "../../../assets/img/landings/nextres/what-we-did/5.webp";
import png6 from "../../../assets/img/landings/nextres/what-we-did/6.png";
import webp6 from "../../../assets/img/landings/nextres/what-we-did/6.webp";
import png7 from "../../../assets/img/landings/nextres/what-we-did/7.png";
import webp7 from "../../../assets/img/landings/nextres/what-we-did/7.webp";

export const data = {
  hero: {
    title: "Private Lender",
    subtitle: "Mortgage loans solutions",
    text: [
      `Brokers and borrowers are always searching for the best mortgage loans available. And with Private Lender, that’s exactly what they get. Private Lender offers a suite of products matched only by the uncompromised support of their experts who are there at every stage of the process, from application review to signing the dotted line. However, every business needs support – and that’s where Agilistry came in.`,
    ],
  },
  problem: {
    title: "The Problem",
    text: [
      `Private Lender sought the help of Agilistry to unify and update their ecosystem. The company wanted to make their services more easily available, encourage real-time decision-making, and elevate the customer experience overall.`,
    ],
    tooltip: [
      {
        icon: "",
        title: "✅ 32%",
        hiddenTitle: "✅ 32% more users",
        text: "More people finish registration survey. Reworked UI / UX helped to make process more clear and less complex for users. ",
      },
      {
        icon: "",
        title: "🏦 4.2%",
        hiddenTitle: "🏦 4.2% more leads",
        text: "More people successfully get approved for loan. Achieved by making documentation requirements more clear, implemented hand-crafted DocGenie document generation system.",
      },
      {
        icon: "",
        title: "🔐 x3",
        hiddenTitle: "🔐 x3 more secure",
        text: "Adding security layers into Private Lender’ system resulted in higher business trustwirthiness.",
      },
    ],
  },
  solution: {
    title: "The Solution",
    text: [
      `Agilistry successfully optimized Private Lender’ user flow by improving and extending functionality. With a more user-friendly ecosystem, Private Lender’ prospects are now taken through a more intuitive funnel that gently guides them along the road to purchase.`,
    ],
  },
  whatWeDid: {
    title: "What We Did",
    text: [
      `After reviewing Private Lender’ existing services, we proposed one website for each target audience. Each of the four resources were revised in terms of:`,
    ],
    list: [
      "UI/UX Design",
      "Functionality Extension",
      "Digital E-Signing System Integration",
      "Business Consulting",
    ],
  },
  list: [
    {
      title: "UI / UX Redesign",
      images: {
        png: png1,
        webp: webp1,
      },
      text: [
        `The main UX challenge was to split the customer flow between segregated web services for brokers, borrowers, and appraisers. Agilistry managed to successfully reinforce the brand through cross-branch unification.`,
      ],
    },
    {
      title: "Document Generation Module",
      images: {
        png: png2,
        webp: webp2,
      },
      text: [
        `Document preparation for the creditor bank is undoubtedly one of the most important parts of the application process. However, digitalization empowered Private Lender to upgrade an outdated model and make it easier for customers to complete and sign the full suite of documentation.`,
      ],
    },
    {
      title: "Depreciation Report",
      images: {
        png: png3,
        webp: webp3,
      },
      text: [
        `It’s no secret that depreciation rates impact property value. Thankfully, Agilistry empowered Private Lender to track this via a dedicated depreciation report. Users can filter their view on a single loan’s level to reveal all of the information they need.`,
      ],
    },
    {
      title: "Functional Authorization Structure",
      images: {
        png: png4,
        webp: webp4,
      },
      text: [
        `Agilistry equipped Private Lender with a functional structure for authorization via one clear and simple form. Users can log in according to their roles and enjoy an additional layer of security.`,
      ],
    },
    {
      title: "Loan Calculations Update",
      images: {
        png: png5,
        webp: webp5,
      },
      text: [
        `Decision-making should be simple and productive, which is why we updated and reviewed all 6 types of loan calculations for Private Lender. We detected and implemented various decision-making parameters, which users can now explore and select by completing the questionnaire.`,
      ],
    },
    {
      title: "Business Analysis & Logic Upgrade",
      images: {
        png: png6,
        webp: webp6,
      },
      text: [
        `We carried out comprehensive competitor analysis on Private Lender’ behalf, accompanied by due diligence of all existing services. With our analysis and report in tow, we proposed an updated structure for the business while optimizing all project documentation for implementation.`,
      ],
    },
    {
      title: "Digital Signing System",
      images: {
        png: png7,
        webp: webp7,
      },
      text: [
        `Digital signing has opened up a new world of possibility, making customers’ lives easier while revealing new business development opportunities. With our standalone, customized e-signing system, multiple parties can sign documents online. Digital signatures are just as legally binding as their traditional counterparts. As a bonus, e-signing is more secure and protects data integrity.`,
      ],
    },
  ],
};
